import Service from 'react-reservice';

export interface IMaintenanceContext {
  underMaintenance?: boolean;
}

const defaultContext: IMaintenanceContext = {
  underMaintenance: false
};

class MaintenanceService extends Service<IMaintenanceContext> {
  constructor() {
    super();
    this.context = { ...defaultContext };
  }

  setUnderMaintenance = (underMaintenance: boolean) => {
    this.context.underMaintenance = underMaintenance;
  };

  reset = () => {
    this.context = { ...defaultContext };
  };
}

export const maintenanceService = new MaintenanceService();
